export class DeliveryOrderStatusCodes {
    static readonly created = 'CRT';
    static readonly waitingForApproval = 'WFA';
    static readonly approved = 'APP';
    static readonly completed = 'COM';
    static readonly cancelled = 'CAN';
    static readonly declined = 'DEC';
    static readonly deleted = 'DLT';
    static readonly pendingFinalApproval = 'PFA';
}
